<template>
  <div class="fadeIn" style="height: 100%;">
    <transition v-if="step === 1" enter-active-class="slideInRight" leave-active-class="slideOutRight">
      <add-adress :addressobj="addressobj" :location="location" :flatActiveGps="flatActiveGps" @goToBack="goToBack" @goToSearchAdress="goToSearchAdress" @openModalGps="openModalGps" @goToHomeDelivery="goToHomeDelivery" />
    </transition>
    <transition v-if="step === 2" enter-active-class="slideInRight" leave-active-class="slideOutRight">
      <address-result :addressobj="addressobj" :instance="instance" @cleanAddress="cleanAddress" @openModalGps="openModalGps" @goToMap="goToMap" @goToBackAddAddress="goToBackAddAddress" />
    </transition>
    <transition v-if="step === 3" enter-active-class="slideInRight" leave-active-class="slideOutRight">
      <map-address :addressobj="addressobj" :location="location" @goToSearchAdress="goToSearchAdress" @goToCompleteAddress="goToCompleteAddress" @cleanAddress="cleanAddress" @goToHomeDelivery="goToHomeDelivery" />
    </transition>
    <transition v-if="step === 4" enter-active-class="slideInRight" leave-active-class="slideOutRight">
      <complete-address :addressobj="addressobj" :polygon="polygon" :location="location" :supplier="supplier" :instance="instance" @cleanAddress="cleanAddress" @goToSearchAdress="goToSearchAdress" @goToHomeDelivery="goToHomeDelivery" />
    </transition>
    <!-- modal de gps -->
    <transition enter-active-class="fadeInDown" leave-active-class="fadeOutUp">
      <v-dialog v-model="watchModalGps" max-width="500px" transition="dialog-transition" scrollable persistent>
        <request-gps-modal :loading="loading" @closeModalGps="closeModalGps" @getGpsLocation="getGpsLocation" />
      </v-dialog>
    </transition>
    <!-- modal de no encontro dirección gps -->
    <transition v-if="alertGps" enter-active-class="fadeInDown" leave-active-class="fadeOutUp">
      <div  class="delivery-modalMap">
        <div class="delivery-modalMapInner">
          <b class="title" v-html="$t('DELIVERY.LOCATION.alert_gps')" />
          <div class="delivery-modalAddressInfo" />
          <button class="delivery-btnAddress" v-html="$t('DELIVERY.LOCATION.again_try')" @click="disibleButtonGps()" data-testid= "setLocation-deliverybtn" />
        </div>
      </div>
    </transition>
    <!-- modal de guardar localización -->
    <v-dialog v-model="saveLocation" class="delivery-wrapModal" width="600px" transition="dialog-transition" persistent>
      <v-card class="text-center" data-testid="SetLocatiion-ModalSaveLocation">
        <div class="google-maps-dialog-title pa-2 font-weight-black" v-html="$t('service.location.continue_direcction')" />
        <v-card-subtitle v-if="location !== null" v-html="location.address"  class="txt-address"/>
        <v-card-text>
          <v-btn class="delivery-noBtn"  @click="setLocationPopUp(false)" v-html="$t('no')" data-testid="SetLocation-noBtn"/>
          <v-btn class="delivery-siBtn" @click="setLocationPopUp(true)" v-html="$t('yes')" data-testid="SetLocation-siBtn"/>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- modal de alerta -->
    <transition  enter-active-class="fadeInDown" leave-active-class="fadeOutUp">
      <div v-if="alertNoDeliveryActive" class="delivery-modalMap">
        <div class="delivery-modalMapInner">
          <b class="title" v-html="messagessAlert" />
          <button class="delivery-btnAddress" v-html="$t('common.close_button_label')" @click="closeAlertModal()" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapMutations,mapState } from "vuex";
import { track } from "@/services/track-custom";
let count = 0;

export default {
  name: "SetLocation",
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.name !== 'Main' && vm.$store.state.profile.location?.supplier_id) vm.saveLocation = false;
    });
  },

  components: {
    RequestGpsModal: () => import(/* webpackChunkName: "RequestGpsModal" */'@/components/delivery/SetLocation/RequetsGps.vue'),
    AddAdress: () => import(/* webpackChunkName: "AddAdress" */'@/components/delivery/SetLocation/AddAddress.vue'),
    AddressResult: () => import(/* webpackChunkName: "AdressResult" */'@/components/delivery/SetLocation/AddressResult.vue'),
    MapAddress: () => import(/* webpackChunkName: "MapAddress" */'@/components/delivery/SetLocation/MapAddress.vue'),
    CompleteAddress: () => import(/* webpackChunkName: "CompleteAddress" */'@/components/delivery/SetLocation/CompleteAddress.vue')
  },
  data() {
    return {
      watchModalGps: false,
      alertGps: false,
      loading: false,
      saveLocation: false,
      addressobj: {},
      step: 1,
      flatActiveGps: true,
      alertNoDeliveryActive: false,
      alertLocation: false,
      messagessAlert: String
    };
  },
  computed: {
    ...mapState('order', ["service"]),
    ...mapState('customer', ["instance", "polygon","supplier"]),
    ...mapState('profile', ["session","location","place"])
  },
  created () {
    this.SetLoading(true);
    this.setService("delivery");
    if (this.$route.query.subservice && this.$route.query.subservice === 'schedule' ) this.setSchedule();
    this.openModalSaveLocation();
  },
  methods: {
    ...mapMutations('order', ["setService", "setSchedule"]),
    ...mapMutations('profile', ["setLocation"]),
    ...mapMutations('customer', ["SetPolygon", "SetSupplier"]),
    ...mapMutations('template', ["SetLoading"]),
    calculate() {
      count++;
      return count;
    },
    openModalSaveLocation() {
      this.saveLocation = (this.location?.supplier_id) ? true : false;
    },
    getGpsLocation() {
      this.calculate();
      if (count > 2) {
        this.watchModalGps = false;
        this.messagessAlert = this.$t('DELIVERY.LOCATION.alert_get_gps_location');
        this.alertNoDeliveryActive = true;
        this.loading = false;
        return;
      };
      this.geolocationInNavigator();
    },
    geolocationInNavigator () {
      this.loading = true;
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(pos => {
            if (pos) {
              this.locationGps = {
                latitud: pos.coords.latitude,
                longitud: pos.coords.longitude
              };
              this.getAddressByLocation();
            } else {
              this.loading = false;
            };
          },
          error => {
            console.error(error);
            this.loading = false;
          }
        );
      } else {
        this.messagessAlert = this.$t('DELIVERY.LOCATION.geolocation_faild');
        this.alertNoDeliveryActive = true;
        this.loading = false;
      };
    },
    closeAlertModal () {
      this.messagessAlert = String;
      this.alertNoDeliveryActive = false;
    },
    async getAddressByLocation() {
      const geocoder = new window.google.maps.Geocoder();
      const latlng = {
        lat: Number(this.locationGps.latitud),
        lng: Number(this.locationGps.longitud)
      };
      await geocoder.geocode({ location: latlng }, (results, status)  => {
        this.alertGps = false;
        if (status === "OK" && results) {
          let placeFound = results[0];
          this.addressobj.address = placeFound.formatted_address;
          this.addressobj.placeFound = placeFound;
          this.goToMap();
        } else {
          this.alertGps = true;
          window.alert("Geocoder failed due to: " + status);
        };
        this.loading = false;
        this.watchModalGps = false;
      });
    },
    closeModalGps () {
      this.watchModalGps = false;
    },
    setLocationPopUp (item) {
      if (item) {
        this.step = 4;
      } else {
        this.clearData();
        this.step = 1;
      };
      this.saveLocation = false;
    },
    clearData () {
      this.setLocation({
        supplier_id: null
      });
      this.SetPolygon({
        supplier_id: null
      });
      this.SetSupplier({
        id: 0
      });
    },
    goToHomeDelivery() {
      let supplier_id;
      if (this.supplier.id > 0) {
        supplier_id = this.supplier.slug;
      } else {
        const firstSupplier = this.instance.suppliers_delivery.find(element => element.active_delivery === true);
        if (firstSupplier) {
          supplier_id = firstSupplier.slug;
        } else {
          this.messagessAlert = this.$t('DELIVERY.LOCATION.no_active_delivery');
          this.alertNoDeliveryActive = true;
        };
      };
      if (supplier_id) {
        this.$router.push({
          name: "Home",
          params: { supplier_id: supplier_id }
        });
      };
    },
    goToBack () {
      this.$router.go(-1);
    },
    goToSearchAdress () {
      this.step = 2;
    },
    goToMap () {
      this.step = 3;
    },
    openModalGps () {
      this.watchModalGps = true;
    },
    cleanAddress () {
      this.clearData();
      this.addressobj = {};
      this.step = 1;
    },
    goToCompleteAddress () {
      this.step = 4;
    },
    disibleButtonGps () {
      this.alertGps = false;
      this.flatActiveGps = false;
    },
    goToBackAddAddress () {
      this.step = 1;
    }
  },
  mounted () {
    this.SetLoading(false);
    track.trackView(this, `Set location`, `/location`);
    track.trackEventCluvi({}, 'view set location');
  }
};
</script>

